<template>
  <div style="background:#000000">
    <van-sticky :z-index="zindex">
      <div :class="[{'vmd_headN':zindex<0},{'vmd_headS':zindex>=0},'vmd_head']" :style="'z-index: '+zindex+';'" class="vmd_head">
        <div class="vmd_head_le">
          斐燃月卡
          <label class="vmd_head_le1">￥</label>
          <label class="vmd_head_le2">998</label>
          <label class="vmd_head_le3">1500</label>
        </div>
        <div  @click="toWXBuyCard()" class="vmd_head_ri">200张限量预购</div>
      </div>
    </van-sticky>

    <div class="monc1">
      <!-- <img class="monc1_img" src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/28.png" /> -->
      <div class="monc1_block_mask"></div>
      <div class="monc1_block">
        <div class="monc1_block_tag_ing">
          <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/27.png" />
        </div>
        <div @click="toWXBuyCard()" class="monc1_item">
          <div class="monc1_itemle">
            <label class="monc1_itemle1">￥</label>
            <label class="monc1_itemle2">998</label>
            <label class="monc1_itemle3">1500</label>
          </div>
          <div class="monc1_itemri">
            200张限量预购
          </div>
        </div>
        <div class="monc1_block_img_tips">预售截止至6月5日</div>
        <div class="monc1_block_img">
          <img @click="srcollSpHeight()" src="https://yoga-union.oss-cn-shanghai.aliyuncs.com/resource/1653709818.gif" />
        </div>

      </div>
    </div>



    <div class="monc2 Anchorlocation"  id="anchor">
      <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/11.png" />
    </div>

    <div class="monc3">
      <div class="monc3_swiper">
        <van-swipe  autoplay="2000" :show-indicators="false" :loop="true" :stop-propagation="true" @change="vanSwipeChange">
          <van-swipe-item class="vindex_banner_item" v-for="(item,key) in banner" :key="key">
            <!-- <img :src="item.img" /> -->
            <div class="monc3_swiper_item" :style="'background-image: url('+item+');'"></div>
            <!-- <div class="vindex_banner_item_indicators">
              <span :class="[{'indicators_block_current':key==keyVlaue},'indicators_block']" v-for="(itemIcon,keyVlaue) in banner" :key="keyVlaue"></span>
            </div> -->
          </van-swipe-item>
        </van-swipe>
        <div class="monc3_swiper_bimg">
          <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/18.png" />
        </div>
        <div class="monc3_swiper_pointer">
          <div v-for="(item_po,key_po) in banner" :key="key_po" :class="[{'monc3_swiper_pointer_itemS':key_po==mc3_current_index},'monc3_swiper_pointer_item']"></div>
        </div>
      </div>
      <img class="monc3_bg" src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/12.png" />
    </div>

    <div class="monc4">
      <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/19.png" />
      <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/20.png" />
      <img src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/21.png" />
    </div>

    <div class="monc5">
      <img class="monc5_img" src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/22.png" />
      <img class="monc5_img" src="https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/23.png" />
      <div class="monc5_btn">
        <div  @click="toWXBuyCard()" class="monc5_sub">
          <label class="monc5_sub1">￥</label>
          <label class="monc5_sub2">998</label>
          <label class="monc5_sub3">预购囤卡</label>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        banner:[
          'https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/13.png',
          'https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/14.png',
          'https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/15.png',
          'https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/16.png',
          'https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/17.png',
        ],

        mc3_current_index:0,
        zindex:-1,

        screenWidth:375,
        screenHeight:667,

      }
    },
    created() {

    },
    mounted() {
      window.addEventListener('scroll',this.scrollHandle);//绑定页面滚动事件

      const that = this;
      window.screenWidth = document.documentElement.clientWidth; //实时宽度
      window.screenHeight = document.documentElement.clientHeight; //实时高度
      that.screenWidth = window.screenWidth;
      that.screenHeight = window.screenHeight;
      console.log(this.screenWidth, this.screenHeight);

      // this.getJsAuth()

      // this.bb_couponClick()
      // var that = this;
      // setTimeout(function(){
      //   alert('that.getJsAuth')
      // 	that.getJsAuth()
      // 	// console.log("111111");
      // },2000);
    },
    watch: {

    },
    methods: {
      getJsAuth() {

      },
      srcollSpHeight(){
        let header = document.querySelector(".Anchorlocation")
        header.scrollIntoView({
          behavior: "smooth",
        })
      },
      vanSwipeChange(e){
        // console.log(e)
        this.mc3_current_index=e
      },
      scrollHandle(e){
        let top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
        console.log(top);
        if(top<3700){
          this.zindex=99
          if(top>812){
            this.zindex=99
          }else{
            this.zindex=-1
          }
        }else{
          this.zindex=-1
        }



        let hclientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // console.log('设备高度：'+hclientHeight)
        var anchor = this.$el.querySelector('#anchor')
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        // // console.log(anchor.offsetTop)
        // console.log(anchor.offsetTop)
        // console.log(scrollTop)
        // console.log(anchor.offsetTop - scrollTop)
        // if(anchor.offsetTop - scrollTop>hclientHeight+40){
        //   this.fxfirstactivity=true
        // }else{
        //   this.fxfirstactivity=false
        // }




      },
      toWXBuyCard(){
        // toolgetUrlScheme
        var $this = this
        // this.$loading('加载中');
        let param = {
          path: '/pages/activity/getcoupon/getcoupon',
          query:'code=2cssx939hga0'
        }
        var qs = require('qs');
        let url = this.api.userApi.toolgetUrlScheme
        // console.log('flGetUserInfoByOpenid')
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code==200) {
            location.href=result.data.openlink
          } else {
            // $this.$loading.close()
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
          // $this.$toast('error');
        })
        // window.location.href='weixin://dl/business/?t=wYfWQ1ZbZnn'
        // this.$dialog.alert({
        //   title: '提示',
        //   message: '等小程序上线后才会有链接跳转',
        // }).then(() => {
        //   // on close
        // });
      }
    },
    destroyed() {

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

  img{
    vertical-align: bottom;
  }
  .monc1{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    background-image: url('https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/28.png');
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100% auto;
    .monc1_img{
      width:100%;
      height: 100vh;
    }
    .monc1_block_mask{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 60vh;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
    }
    .monc1_block{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      padding: 0 50*@vm_base 45*@vm_base 50*@vm_base;
      .monc1_block_tag_ing{
        width: 100%;
        margin-bottom: 20*@vm_base;
        img{
          width: 100%;
        }
      }
      .monc1_item{
        width: 100%;
        display: flex;

        background-image: url(http://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/26.png);
        background-position: center top;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        justify-content: space-between;
        align-items: center;
        // background: linear-gradient(198deg, rgba(149, 175, 233, 0.68) 0%, rgba(252, 234, 181, 0.08) 100%) linear-gradient(181deg, rgba(252, 234, 181, 0.88) 0%, rgba(149, 187, 233, 0) 100%) linear-gradient(188deg, rgba(253, 173, 117, 0.36) 0%, rgba(0, 0, 0, 0) 100%);
        border-radius: 4*@vm_base;
        // border: 1*@vm_base solid #FFFFFF;
        padding: 20*@vm_base 0;
        .monc1_itemle{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .monc1_itemle1{
            font-size: 26*@vm_base;
            font-weight: 600;
            color: #FFFFFF;
          }
          .monc1_itemle2{
            font-size: 48*@vm_base;
            font-weight: 600;
            color: #FFFFFF;
          }
          .monc1_itemle3{
            font-size: 26*@vm_base;
            font-weight: 500;
            color: #FFFFFF;
            text-decoration: line-through;
            margin-left: 16*@vm_base;
          }
        }
        .monc1_itemri{
          width: 100%;
          height: 50*@vm_base;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          letter-spacing: 1px;
          // border-left: 1*@vm_base solid #ffffff;
        }
      }
      .monc1_block_img{
        width: 100%;
        margin-top: 28*@vm_base;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          height: 56*@vm_base;transform: rotate(180deg)
        }
      }
      .monc1_block_img_tips{
        width: 100%;
        text-align: center;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 32*@vm_base;
        letter-spacing: 1px;
        opacity: 0.8;
      }
    }
  }
  .vmd_headN{
    height: 0;
  }
  .vmd_headS{
    height: 100*@vm_base;
  }
  .vmd_head{
    width: 100%;
    // height: 100*@vm_base;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40*@vm_base;

  }
  .vmd_head_le{
    font-size: 30*@vm_base;
    font-weight: 500;
    color: #000000;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .vmd_head_le1{
    font-size: 26*@vm_base;
    font-weight: 600;
    color: #000000;
  }
  .vmd_head_le2{
    font-size: 48*@vm_base;
    font-weight: 600;
    color: #000000;
  }
  .vmd_head_le3{
    font-size: 26*@vm_base;
    font-weight: 500;
    color: #000000;
    text-decoration: line-through;
    margin-left: 15*@vm_base;
  }
  .vmd_head_ri{
    width: 286*@vm_base;
    height: 72*@vm_base;
    border-radius: 4*@vm_base;
    border: 1*@vm_base solid #684609;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30*@vm_base;
    font-weight: 500;
    color: #684609;
    letter-spacing: 1px;
  }
  .monc2{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .monc3{
    width: 100%;
    position: relative;
    .monc3_bg{
      width: 100%;
    }
    .monc3_swiper{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 40*@vm_base;
      margin-bottom: 90*@vm_base;
      .vindex_banner_item{
        width: 100%;
      }
      .monc3_swiper_item{
        width: 100%;
        height: 640*@vm_base;
        background-position: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .monc3_swiper_bimg{
        width: 100%;
        img{
          width: calc(100% - 60*@vm_base);
          margin-left: 30*@vm_base;
        }
      }
    }
    .monc3_swiper_pointer{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32*@vm_base;
      .monc3_swiper_pointer_item{
        width: 20*@vm_base;
        height: 20*@vm_base;
        border: 2*@vm_base solid #fff;
        border-radius: 50%;
        margin: 0 8*@vm_base;
        background: #ffffff;
      }
      .monc3_swiper_pointer_itemS{
        background: #F2CE88;
      }
    }
  }
  .monc4{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .monc5{
    width: 100%;
    position: relative;
    .monc5_img{
      width: 100%;
    }
    .monc5_btn{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0 120*@vm_base 190*@vm_base 120*@vm_base;
      .monc5_sub{
        width: 100%;
        height: 80*@vm_base;
        background: linear-gradient(177deg, #F0D39E 0%, #F9E9BE 52%, #E3B773 100%);
        box-shadow: 0*@vm_base 10*@vm_base 24*@vm_base 0*@vm_base rgba(87, 81, 71, 0.35), 0*@vm_base 12*@vm_base 2*@vm_base 0*@vm_base rgba(242, 212, 154, 0.58), inset 0px -6px 12px 0px rgba(244, 231, 200, 0.37);
        border-radius: 40*@vm_base;
        display: flex;
        justify-content: center;
        align-items: center;
        .monc5_sub1{
          font-size: 26*@vm_base;
          font-weight: 600;
          color: #000000;
        }
        .monc5_sub2{
          display: inline-block;
          font-size: 48*@vm_base;
          font-weight: 600;
          color: #000000;
          margin-left: 3*@vm_base;
          margin-right: 16*@vm_base;
        }
        .monc5_sub3{
          font-size: 32*@vm_base;
          font-weight: 500;
          color: #000000;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/monthcard/monthcard.vue